// Chef D's — shared theme behavior (ported from js/script.js, scoped with data-chefds-* attributes
// to avoid colliding with Horizon's own header/nav JS on the same page).

document.addEventListener('DOMContentLoaded', () => {
    // Mobile nav toggle
    const burger = document.querySelector('[data-chefds-burger]');
    const mobileNav = document.querySelector('[data-chefds-mobile-nav]');
    if (burger && mobileNav) {
      burger.addEventListener('click', () => {
        mobileNav.classList.toggle('is-open');
        const isOpen = mobileNav.classList.contains('is-open');
        burger.setAttribute('aria-expanded', String(isOpen));
        burger.innerHTML = isOpen
          ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
          : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
      });
      mobileNav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }));
    }

    // Header hide-on-scroll
    const header = document.querySelector('[data-chefds-header]');
    if (header) {
      let lastY = window.scrollY;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        header.classList.toggle('site-header--scrolled', y > 12);
        if (y > lastY && y > 140) header.classList.add('site-header--hidden');
        else header.classList.remove('site-header--hidden');
        lastY = y;
      }, { passive: true });
    }

    // Footer year
    document.querySelectorAll('[data-chefds-year]').forEach((el) => (el.textContent = new Date().getFullYear()));
});
